import Vuex from 'vuex';
import Vue from 'vue';
import auth from './modules/auth';
import blockrule from './modules/blockrule';
import category from './modules/category';
import controlPanel from './modules/controlPanel';
import credit from './modules/credit';
import customer from './modules/customer';
import dashboard from './modules/dashboard';
import dealt from './modules/dealt';
import distribution from './modules/distribution';
import domain from './modules/domain';
import exportation from './modules/exportation';
import extract from './modules/extract';
import featureToggle from './modules/featureToggle';
import integration from './modules/integration';
import interaction from './modules/interaction';
import ip from './modules/ip';
import loop from './modules/loop';
import metadata from './modules/metadata';
import organization from './modules/organization';
import password from './modules/password';
import profile from './modules/profile';
import segment from './modules/segment';
import sso from './modules/sso';
import survey from './modules/survey';
import team from './modules/team';
import template from './modules/template';
import ui from './modules/ui';
import upload from './modules/upload';
import user from './modules/user';
import validator from './modules/validator';
import widget from './modules/widget';

require('babel-polyfill');

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    blockrule,
    category,
    controlPanel,
    credit,
    customer,
    dashboard,
    dealt,
    distribution,
    domain,
    exportation,
    extract,
    featureToggle,
    integration,
    interaction,
    ip,
    loop,
    metadata,
    organization,
    password,
    profile,
    segment,
    sso,
    survey,
    team,
    template,
    ui,
    upload,
    user,
    validator,
    widget,
  },
});

export default store;
